<template>
  <div class="productSort">
    <!--<form @submit.prevent="submitForm">
      <div class="header acea-row row-center-wrapper" ref="header">
        <div class="acea-row row-between-wrapper input">
          <span class="iconfont icon-sousuo"></span>
          <input type="text" placeholder="搜索商品信息" v-model="search" />
        </div>
      </div>
    </form>-->
    <div class="aside">
      <div
        class="item acea-row row-center-wrapper"
        :class="index === navActive ? 'on' : ''"
        v-for="(item, index) in category"
        :key="index"
        @click="asideTap(index)"
      >
        <span>{{ item.cate_name }}</span>
      </div>
    </div>
    <div class="conter" @scroll.native="onScroll">
      <div class="listw" v-for="(item, index) in category" :key="index" v-if="navActive==index">

        <div v-for="(child2, index2) in item.children1" :key="index2" >
          <div class="title row-center-wrapper" ref="title">
            <div class="name">{{ child2.cate_name }}</div>
          </div>
          <div class="list acea-row">
            <router-link
                    class="item acea-row row-column row-middle"
                    v-for="(child3, index3) in child2.children2"
                    :key="index3"
                    :to="{
              path: '/goods_list',
              query: { id: child3.id, title: child3.cate_name }
            }"
            >
              <div class="picture"><img v-lazy="child3.pic" /></div>
              <div class="name line1">{{ child3.cate_name }}</div>
            </router-link>
          </div>
        </div>



      </div>
    </div>
    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
import debounce from "lodash.debounce";
import { getCategory } from "@api/store";
import { trim } from "../../utils";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils/index";
import { getHomeData, getShare, follow } from "@api/public";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { getUser,getUserOpenId, getMenuUser } from "@api/user";
export default {
  name: "GoodsClass",
  components: {},
  props: {},
  data: function() {
    return {
      category: [],
      navActive: 0,
      search: "",
      lock: false
    };
  },
  watch: {
    /*"$route.params.pid": function(n) {
      if (n) {
        this.activeCateId(n);
      }
    }*/
  },
  computed: mapGetters(["isLogin"]),
  mounted: function() {
    //document.addEventListener("scroll", this.onScroll, false);
    this.loadCategoryData();
    this.setOpenShare();
  },
  methods: {
    /*activeCateId(n) {
      let index = 0;
      n = parseInt(n);
      if (!n) return;
      this.category.forEach((cate, i) => {
        if (cate.id === n) index = i;
      });

      if (index !== this.navActive) {
        this.asideTap(index);
      }
    },*/
    loadCategoryData() {
      getCategory().then(res => {
        this.category = res.data;
        this.navActive = 0;
        /*this.$nextTick(() => {
          if (this.$route.params.pid) this.activeCateId(this.$route.params.pid);
          //else this.onScroll();
        });*/
      });
    },
    submitForm: function() {
      var val = trim(this.search);
      if (val) {
        this.$router.push({
          path: "/goods_list",
          query: { s: val }
        });
        setTimeout(() => (this.search = ""), 500);
      }
    },
    asideTap(index) {
      /*const top =
        this.$refs.title[index].offsetTop -
        this.$refs.header.offsetHeight -
        window.scrollY;

      this.lock = true;

      window.scrollBy({ top, left: 0, behavior: "smooth" });*/
      this.navActive = index;
    },
    /*onScroll: debounce(function() {
      if (this.lock) {
        this.lock = false;
        return;
      }
      const headerHeight = this.$refs.header.offsetHeight,
        { scrollY } = window,
        titles = this.$refs.title;
      titles.reduce((initial, title, index) => {
        if (initial) return initial;
        const parent = title.parentNode || title.parentElement;
        if (
          scrollY + headerHeight + 15 <
          title.offsetTop + parent.offsetHeight
        ) {
          initial = true;
          this.navActive = index;
        }
        return initial;
      }, false);
    }, 500),*/

      setOpenShare() {
          if (isWeixin()) {
              if(this.isLogin){

                  getUser().then(res => {
                      var href = location.href;

                  href =
                      href.indexOf("?") === -1
                          ? href + "?spread=" + res.data.uid
                          : href + "&spread=" + res.data.uid;
                  var nickname = res.data.nickname;


                  getShare().then(res => {
                      var data = res.data.data;
                  var configAppMessage = {
                      desc: '['+nickname+'邀请] '+data.synopsis,
                      title: data.title,
                      link: href,
                      imgUrl: data.img
                  };
                  openShareAll(configAppMessage);
              });
              })
              }else{
                  getShare().then(res => {
                      var data = res.data.data;
                  var configAppMessage = {
                      desc: data.synopsis,
                      title: data.title,
                      link: location.href,
                      imgUrl: data.img
                  };
                  openShareAll(configAppMessage);
              });
              }


          }
      }
  },
 /* beforeDestroy: function() {
    document.removeEventListener("scroll", this.onScroll, false);
  }*/

};
</script>
